var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"plain":"","size":_vm.size,"icon":"el-icon-back"},on:{"click":_vm.goBack}},[_vm._v(_vm._s(`返回${_vm.content}列表`))])
}
var staticRenderFns = []

export { render, staticRenderFns }